/**
 * CHASER — bind S/M/L size pickers to add-to-cart forms as line-item properties.
 */

/**
 * @param {ParentNode} [root]
 */
export function bindProductSizePickers(root = document) {
  const pickers = root.querySelectorAll('[data-product-size-picker]');

  pickers.forEach((picker) => {
    if (!(picker instanceof HTMLElement)) return;
    if (picker.dataset.bound === 'true') return;

    const scope =
      picker.closest('.product-details') ||
      picker.closest('[data-product-grid-content]') ||
      picker.closest('quick-add-dialog') ||
      picker.closest('#quick-add-modal-content') ||
      root;

    const form = scope.querySelector('form[data-type="add-to-cart-form"]');
    if (!(form instanceof HTMLFormElement)) return;

    picker.dataset.bound = 'true';

    let propertyInput = form.querySelector('input[name="properties[Size]"]');
    if (!(propertyInput instanceof HTMLInputElement)) {
      propertyInput = document.createElement('input');
      propertyInput.type = 'hidden';
      propertyInput.name = 'properties[Size]';
      form.appendChild(propertyInput);
    }

    const sync = () => {
      const selected = picker.querySelector('[data-product-size-input]:checked');
      propertyInput.value = selected instanceof HTMLInputElement ? selected.value : '';
    };

    sync();
    picker.addEventListener('change', sync);
    form.addEventListener('submit', sync, true);
  });
}

const observeForPickers = () => {
  bindProductSizePickers(document);

  const observer = new MutationObserver(() => {
    bindProductSizePickers(document);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeForPickers, { once: true });
} else {
  observeForPickers();
}
